import { isNil } from 'ramda';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { EJsonQueryType } from '../../types/jsonQuery/term';

/**
 * Проверяет вхождение jsonQuery в другой jsonQuery
 * @param {IJsonQuery} jsonQuery - эталонный jsonQuery
 * @param {IJsonQuery} partJsonQuery - jsonQuery для сравнения
 * @returns {boolean}
 */
export const containsJsonQuery = (jsonQuery: IJsonQuery, partJsonQuery: Partial<IJsonQuery>): boolean => {
  const partJsonQueryKeys = Object.keys(partJsonQuery) as (keyof IJsonQuery)[];
  const jsonQueryKeys = Object.keys(jsonQuery) as (keyof IJsonQuery)[];
  const compareKeys = partJsonQueryKeys.filter(key => !isNil(partJsonQuery[key]));
  const jsonQueryNotNullKeys = jsonQueryKeys.filter(key => !isNil(jsonQuery[key]));

  // Для чипа "Все"
  if (partJsonQueryKeys.length === 0 && jsonQueryNotNullKeys.length === 0) {
    return true;
  }

  // partJsonQuery не содержит валидных полей
  if (!compareKeys.length) {
    return false;
  }

  for (const key of compareKeys) {
    const jsonQueryItem = jsonQuery[key];
    const partJsonQueryItem = partJsonQuery[key] as Exclude<IJsonQuery[typeof key], null | undefined>;

    if (isNil(jsonQueryItem)) {
      return false;
    }

    if (jsonQueryItem.type === EJsonQueryType.Term && jsonQueryItem.value !== partJsonQueryItem.value) {
      return false;
    }

    if (jsonQueryItem.type === EJsonQueryType.Terms) {
      const partialValue = (partJsonQueryItem as typeof jsonQueryItem).value;

      const includesJsonQueryValue = <T extends (typeof partialValue)[0]>(value: T) =>
        (jsonQueryItem.value as T[]).includes(value);

      // TS не понимать union тип
      if (!(partialValue as unknown[]).every(includesJsonQueryValue)) {
        return false;
      }
    }
  }

  return true;
};
